export default __webpack_public_path__ + "2e4474d52e4d27a1eafa923aee55cd00.jpg";